import React, { useState, useRef, useEffect } from 'react'
import MUIDataTable from 'mui-datatables'
import Checkbox from '@mui/material/Checkbox'
import { Modal, Grid } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import dayjs, { Dayjs } from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/Loader'
import 'moment-timezone'
import { routeMapGet, updateRouteMap } from '../../actions/settings';


const RouteMap = ({ history }) => {

    const [openCongrModal, setOpenCongrModal] = useState(false)
    const [responsive, setResponsive] = useState('simple')
    const dispatch = useDispatch()
    const merchant = useSelector((state) => state.merchant)
    const user = useSelector((state) => state.user)

    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)

    const loaders = useSelector((state) => state.loader)

    const [files, setFile] = useState(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [error, setError] = useState('')
    const [imgerror, setImgError] = useState(false)
    const settings = useSelector((state) => state.settings)

    const tableRef = useRef(null);
    const [tableHeight, setTableHeight] = useState('auto');

    useEffect(() => {
        const updateTableHeight = () => {
        if (tableRef.current) {
            const rect = tableRef.current.getBoundingClientRect();
            console.log("rect", rect);
            const remainingHeight = window.innerHeight - rect.top;
            const newHeight = remainingHeight - 60; // Subtract 100px as per requirement
            setTableHeight(newHeight);
            console.log(newHeight);
        }
        };

        updateTableHeight();
        window.addEventListener('resize', updateTableHeight);

        return () => {
        window.removeEventListener('resize', updateTableHeight);
        };
    }, []);

    // drag state
    const [dragActive, setDragActive] = React.useState(false)
    // ref
    const inputRef = React.useRef(null)
    const myRefs = React.useRef([]);
    myRefs.current = settings.routeMap.map((element, i) => myRefs.current[i] ?? React.createRef());
    // handle drag events
    const handleDrag = function (e) {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true)
        } else if (e.type === 'dragleave') {
            setDragActive(false)
        }
    }

    useEffect(() => {
        if (user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin) {
            history.push("/settings")

        }

    }, [])

    // triggers when file is dropped
    const handleDrop = function (e) {
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const MAX_FILE_SIZE = 5120 // 5MB

            const fileSizeKiloBytes = e.dataTransfer.files[0].size / 1024

            const allowedTypes = ['image/jpeg', 'image/png']
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                setError('File size is greater than maximum limit')
                setImgError(true)
                return
            } else if (!allowedTypes.includes(e.dataTransfer.files[0]?.type)) {
                setError('Only JPEG, and PNG images are allowed.')
                setImgError(true)
                return
            } else {
                setError('')
                setImgError(false)
                getBase64(e.dataTransfer.files[0])
                    .then((result) => {
                        var file = result.split(',')
                        setFile(file[1])
                    })
                    .catch((err) => { })

                var reader = new FileReader()
                var url = reader.readAsDataURL(e.dataTransfer.files[0])

                reader.onloadend = function (e) {
                    setImgError(false)
                    setImageUrl(reader.result)
                }.bind(this)
            }
        }
    }

    const getBase64 = (file) => {
        return new Promise((resolve) => {
            let fileInfo
            let baseURL = ''
            // Make new FileReader
            let reader = new FileReader()

            // Convert the file to base64 text
            reader.readAsDataURL(file)

            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                baseURL = reader.result
                resolve(baseURL)
            }
        })
    }

    const handleChange = function (e, data, param) {
        e.preventDefault()
        if (e.target.files && e.target.files[0]) {
            // const droppedFiles = Array.from(e.target.files[0]);
            // setFile(e.target.files[0]);
            const MAX_FILE_SIZE = 5120 // 5MB

            const fileSizeKiloBytes = e.target.files[0].size / 1024

            const allowedTypes = ['application/pdf']
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                setOpenCongrModal(true);
                setError('File size is greater than maximum limit')
                setImgError(true)
                return
            } else if (!allowedTypes.includes(e.target.files[0]?.type)) {
                setOpenCongrModal(true);
                setError('Only PDF is allowed.')
                setImgError(true)
                return
            } else {
                setError('')
                setImgError(false)
                setOpenCongrModal(false);

                getBase64(e.target.files[0])
                    .then((result) => {
                        var file = result.split(',')

                        dispatch((updateRouteMap({
                            "id": data[2],
                            "route_id": data[0],
                            "map_url": file[1]
                        }, (res) => {
                            dispatch(routeMapGet(null, (res) => { }))
                        })))
                    })
                    .catch((err) => { })

                var reader = new FileReader()
                var url = reader.readAsDataURL(e.target.files[0])

                reader.onloadend = function (e) {
                    setImgError(false)
                    setImageUrl(reader.result)
                }.bind(this)
            }
        }
    }



    React.useEffect(() => {
        dispatch(routeMapGet({}, (res) => {

        }))
    }, [])


    var newData = []
    //************Setting up paramters for table  */
    useEffect(() => {
        newData = settings.routeMap.map((item, index) => {
            return [
                item.route_id,
                item.map_url,
                item.id,

            ]
        })
        setTimeout(() => {
            setData(newData)
        }, 500)
    }, [settings.routeMap])



    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    //************Setting up paramters for table  */

    const columns = [
        {
            name: 'Route Id',
            label: 'Route ID',
            options: {
                filter: true,
                sort: false,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Route Id</span>
                        </p>
                    )
                },

            },
        },
        {
            name: 'pdf',
            label: 'PDF',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Map URL</span>
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    return (
                        <a href={data[index][1]} target='blank'>{data[index][1]}</a>

                    )
                },
            },
        },

        {
            name: 'Update',
            label: 'Update',
            options: {
                filter: true,

                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Update
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    return (
                        <div><input
                            type='file' ref={myRefs.current[index]}
                            style={{ display: "none" }} onChange={(e) => handleChange(e, data[index])} /><button className="btn btn-primary " style={{ padding: "5px", borderRadius: "5px" }} onClick={() => myRefs.current[index].current.click()}>  <img src={require('../../assets/images/Edit.png')} /></button></div>
                    )
                },
            },
        },

    ]





    const options = {
        //  filterType: 'checkbox',
        title: 'Pie Chart',
        filter: false,
        selectableRowsHideCheckboxes: false,
        sort: true,
        sortOrder: {
            name: 'pdf',
            direction: 'desc',  // Default sorting direction for the 'Date Added' column
          },
        print: false,
        viewColumns: false,
        download: false,
        pagination: false,
        selectableRowsOnClick: false,
        selectableRows: false,
        // onRowClick: (rowData, rowMeta) => {
        //   dispatch(updateSelectedMerchantId(merchant.list[rowMeta.dataIndex].id));
        //   history.push("/merchantItems");
        // },
        selectableRowsHeader: false,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 30],
        caseSensitive: false,
        search: false,
        jumpToPage: true,
        tableBodyHeight: tableHeight,
        tableBodyMaxHeight: "none",
        count: merchant.total_users,
        onChangePage: (currentPage) => {
            setPage(currentPage + 1)
            return
        },
        onChangeRowsPerPage: (numberOfRows) => {
            setLimit(numberOfRows)
        },

        responsive: 'standard',
    }

    const CustomCheckbox = (props) => {
        let newProps = Object.assign({}, props)
        newProps.color = props['data-description'] === 'row-select' ? 'secondary' : 'primary'

        if (props['data-description'] === 'row-select') {
            return <Checkbox />
        } else {
            return <Checkbox {...newProps} />
        }
    }

    const updateValue = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }
    return (
        <div className=" merchantlist">
            <Loader loading={loaders.isFetching} />

            <div className="scroll-fix">
                <div className="titlediv">
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={4}>
                            <div style={{ display: 'flex' }}>
                                <div>
                                    <p className="headinguser">Route Map</p>
                                    {/* <p className="subheadinggraph">
                                        Merchant of Climate Mobility & Safety
                                    </p> */}
                                </div>
                            </div>
                        </Grid>

                    </Grid>
                </div>
                {/* <div className="pagination-wrapper">
                    <div className="pagination">
                        <p>
                            Showing {merchant.list.length} out of {merchant.total_users} merchants{' '}
                        </p>
                    </div>

                    <Stack spacing={2}>
                        <Pagination
                            count={Math.ceil(merchant.total_users / limit)}
                            page={page}
                            onChange={(e, value) => setNewPage(value)}
                            color="primary"
                        />
                    </Stack>
                    <div className="pagination2">
                        <p>Rows Per Page</p>
                        <select onChange={(e) => updatePagination(e)}>
                            <option selected={limit == 5}>5</option>
                            <option selected={limit == 10}>10</option>
                            <option selected={limit == 20}>20</option>
                        </select>
                    </div>
                </div> */}
            </div>

            <div ref={tableRef} style={{ overflowY: 'auto', height: tableHeight }}>
                <MUIDataTable
                    className="custommuitablestyle"
                    columns={columns}
                    data={data}
                    responsive={responsive}
                    // components={{
                    //   Checkbox: CustomCheckbox,
                    // }}

                    rowHover={true}
                    options={options}
                />
            </div>

            <Modal
                open={openCongrModal}
                onClose={() => {
                    setOpenCongrModal(false)
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="congratespopup">
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            {error}
                        </Typography>

                        {/* <Typography>
              <div className='buttonGroupDelete'>

                <button className="btn btn-primary btn-block okaybutton" onClick={() => { setOpenCongrModal(false) }}>Okay
                </button>
              </div>
            </Typography> */}
                    </div>
                </Box>
            </Modal>



        </div>
    )
}

export default RouteMap
